import qrcode from "qrcode-generator";

/** Renders `text` as a crisp black-on-white QR <svg> string. */
export function qrSvg(text: string): string {
  const qr = qrcode(0, "M");
  qr.addData(text);
  qr.make();
  const n = qr.getModuleCount();
  let path = "";
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (qr.isDark(r, c)) path += `M${c},${r}h1v1h-1z`;
    }
  }
  const q = 2; // quiet zone
  return (
    `<svg class="qr" viewBox="${-q} ${-q} ${n + q * 2} ${n + q * 2}" ` +
    `shape-rendering="crispEdges" xmlns="http://www.w3.org/2000/svg">` +
    `<rect x="${-q}" y="${-q}" width="${n + q * 2}" height="${n + q * 2}" fill="#fff"/>` +
    `<path d="${path}" fill="#000"/></svg>`
  );
}
